import { Component, Input } from '@angular/core';
import {
  combineLatest,
  filter,
  forkJoin,
  map,
  Observable,
  startWith,
  switchMap,
  take,
} from 'rxjs';
import { PatternApiService } from 'src/app/services/api/pattern-api.service';
import { ListOfAllPallets } from 'src/app/models_new/config/form_fields';
import { SimulationWizardDataService } from '../../simulation-wizard-data.service';
import { NotificationService } from 'src/app/services/notification.service';
import {
  ITableAction,
  ITableData,
} from '../../../../gui/table/table.component';
import { DataRequestState } from 'src/app/data-request/model';
import { toRequestState } from 'src/app/data-request/operators';
import { determinePalletType } from 'src/app/utils/patterns-utils';

type SelectPatternActions = 'delete';

@Component({
  selector: 'app-select-patterns',
  templateUrl: './select-patterns.component.html',
  styleUrls: ['./select-patterns.component.scss'],
})
export class SelectPatternsComponent {
  public patternTableData$: Observable<
    DataRequestState<ITableData<SelectPatternActions>[]>
  >;
  public columnsToDisplay: string[] = ['select', 'name', 'product', 'pallet'];
  @Input() showDualProductToggle: boolean = true;

  constructor(
    private patternApi: PatternApiService,
    public father: SimulationWizardDataService,
    private notifier: NotificationService
  ) {
    this.patternTableData$ = combineLatest([
      this.father.patterns$,
      // Retrigger the table data when dual product mode changes.
      this.father.zimWizard.dualProductMode.valueChanges.pipe(
        // Start with the current value to trigger the initial fetch.
        startWith(this.father.zimWizard.dualProductMode.value)
      ),
    ]).pipe(
      map(([patterns, _dualProduct]) => {
        let tableData: ITableData<SelectPatternActions>[] = [];
        for (let pattern of patterns) {
          tableData.push({
            data: {
              id: pattern.id,
              name: pattern.name,
              product: pattern.product.name,
              pallet: determinePalletType(
                pattern.data.dimensions,
                ListOfAllPallets
              ),
              pattern: pattern,
            },
            actions: [
              {
                label: 'Delete',
                icon: 'delete',
                actionId: 'delete',
                txtColor: '#AF2B2B',
              },
            ],
          });
        }
        return tableData;
      }),
      toRequestState()
    );
  }

  createPattern() {
    console.error('missing feature');
  }

  actionClicked(event: ITableAction<SelectPatternActions>) {
    if (event.actionId === 'delete') {
      this.deleteCallback(event.element);
    }
  }

  deleteCallback(pattern) {
    this.notifier
      .deletePrompt('Delete', 'pattern', [pattern.name])
      .afterDismissed()
      .pipe(
        take(1),
        filter(Boolean),
        switchMap(() => {
          return this.deletePattern([pattern.id]);
        })
      )
      .pipe(take(1))
      .subscribe((result) => {
        if (result[0]) {
          this.notifier.showMessage(`The pattern was deleted successfully!`);
        } else {
          this.notifier.showError(
            'Unable to delete pattern! Do you have the correct user privilege in your organization?'
          );
        }
      });
  }

  deletePattern(ids: string[]): Observable<any> {
    const operations = {};
    for (let i = 0; i < ids.length; i++) {
      operations[i] = this.patternApi.deletePatternById(ids[i]);
    }
    return forkJoin(operations);
  }
}
